// extracted by mini-css-extract-plugin
export default {"carousel":"Carousel_carousel__OgIMc","item":"Carousel_item__80vl9","itemInfo":"Carousel_itemInfo__DEOq7"};